import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../../shared/providers/base-provider';
import { NowcastingKpiNotifier } from './kpi-notifier';
import { NowcastingKpiState } from './kpi-state';

@Injectable()
export class NowcastingKpiProvider extends BaseProvider<NowcastingKpiNotifier, NowcastingKpiState> {
  constructor() {
    super(NowcastingKpiNotifier);
  }
}
